import * as React from "react"
const SvgReceiptSlip = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M21 5.429a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v15.8q0 .35.3.474.3.126.55-.125l.3-.3a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.3.3q.25.25.55.125t.3-.474zm-2 14.1H5v-14.1h14z"
      clipRule="evenodd"
    />
    <path d="M7 17.429h10q.424 0 .712-.288A.97.97 0 0 0 18 16.43a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287H7a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712.288.288.713.288Z" />
    <path
      fillRule="evenodd"
      d="M7 13.429h10q.424 0 .712-.288A.97.97 0 0 0 18 12.43a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287H7a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712.288.288.713.288Zm0-4h10q.424 0 .712-.288A.97.97 0 0 0 18 8.43a.97.97 0 0 0-.288-.713A.97.97 0 0 0 17 7.43H7a.97.97 0 0 0-.713.287A.97.97 0 0 0 6 8.43q0 .424.287.712.288.288.713.288Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgReceiptSlip
